import {
  EmailSchema,
  PhoneNumberSchema,
} from "@/lib/data/schemas/CommonSchemaFields";
import { z } from "zod";

export const signerEditFormSchema = z.object({
  email: z
    .string()
    .trim()
    .refine((value) => {
      if (!value) return true;
      return EmailSchema.safeParse(value).success;
    }, "Invalid email format"),
  phone: z
    .string()
    .trim()
    .refine((value) => {
      if (!value) return true;
      return PhoneNumberSchema.safeParse(value).success;
    }, "Invalid phone number"),
});

export type SignerEditFormValues = z.infer<typeof signerEditFormSchema>;
